export const emailRouting = {
  pageTitle: '電郵服務商路由',
  defaultProvider: '預設服務商',
  defaultProviderHelp: '當範本設定為「使用預設」時採用此服務商。',
  mailgunNotConfigured:
    '此環境尚未設定 Mailgun。請設定 MAILGUN_API_KEY 與 MAILGUN_DOMAIN 以啟用。',
  resendNotConfigured:
    '此環境尚未設定 Resend。請設定 RESEND_API_KEY 以啟用。',
  col: {
    template: '範本',
    category: '類別',
    recipient: '收件人',
    provider: '服務商',
    enabled: '啟用',
    updated: '最後更新',
    test: '測試',
  },
  status: {
    notImplementedBadge: '未實作',
    notImplementedNote:
      '此範本已註冊，但生產環境尚未有任何代碼會發送此電郵。在此處切換服務商不會生效，直到觸發點被實作。',
  },
  test: {
    button: '發送測試',
    dialogTitle: '發送測試電郵',
    helperText:
      '系統會使用此範本目前所設定的服務商，將真實郵件寄送至以下地址。範本變數會以樣本資料填入。',
    recipientEmail: '收件人電郵地址',
    language: '語言',
    send: '發送測試電郵',
    sending: '發送中…',
    cancel: '取消',
    invalidEmail: '請輸入有效的電郵地址。',
    sendSucceeded: '測試電郵已送往 %{email}。',
    sendFailed: '發送測試電郵失敗',
    disabledHint: '請先啟用此範本才能發送測試電郵。',
  },
  customer: '客戶',
  admin: '管理',
  useDefault: '使用預設（%{default}）',
  saveAll: '儲存所有變更',
  discard: '放棄變更',
  saving: '儲存中…',
  saveSucceeded: '電郵路由已更新',
  saveFailed: '儲存電郵路由失敗',
  loadFailed: '載入電郵路由失敗',
};
